import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

export const IconInsured = ({ className }: PropsWithClassName) => {
  return (
    <div
      className={cn(
        'flex text-xs items-center not-italic justify-center rounded-[50%] font-bold w-[20px] h-[20px] border-[1.35px] relative cursor-pointer',
        className
      )}
    >
      <span className="leading-[0] block">A</span>
    </div>
  );
};
